import type { TFunction } from 'i18next'

import type { PreviousMedicalRecordConsent } from '../types/clinicTypes'

export interface ConsentTexts {
  consentText: string | null
  descriptionText: string
  showConsentLine: boolean
}

export const getConsentTexts = (
  consent: PreviousMedicalRecordConsent['consent'],
  t: TFunction,
  nullDescription: string,
): ConsentTexts => {
  const showConsentLine = consent !== null
  const consentText =
    consent === true
      ? t('Common:PMR_CONSENT.CONSENT_YES')
      : consent === false
        ? t('Common:PMR_CONSENT.CONSENT_NO')
        : null

  const descriptionText =
    consent === true
      ? t('Common:PMR_CONSENT.CONSENT_YES_DESCRIPTION')
      : consent === false
        ? t('Common:PMR_CONSENT.CONSENT_NO_DESCRIPTION')
        : nullDescription

  return {
    consentText,
    descriptionText,
    showConsentLine,
  }
}
